<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>ANGULAR</div>
				<h2 waHeading="l" waText>Java-to-Angular Code Generation</h2>
				<p waBody="m" waColorText="quiet" waText>Annotations in, production Angular 21 out.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Component Generation</h3>
							<p waBody="m" waColorText="quiet" waText>&#64;NgComponent, &#64;NgDirective, &#64;NgDataService &mdash; Java classes become Angular components with templates, imports, and lifecycle hooks. &#64;NgField, &#64;NgSignal, &#64;NgMethod generate TypeScript class members.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Routing</h3>
							<p waBody="m" waColorText="quiet" waText>&#64;NgRoutable&#40;path, redirectTo, pathMatch, parent, sortOrder&#41; defines Angular routes. AngularRoutingModule scans annotated classes and builds RouterModule.forRoot&#40;routes&#41; with parent-child nesting.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Build-Time Pipeline</h3>
							<p waBody="m" waColorText="quiet" waText>The Angular Maven Plugin discovers &#64;NgApp classes, generates .ts sources, package.json, angular.json, tsconfig.json, installs npm dependencies, and runs ng build &mdash; all inside mvn install.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Angular Control-Flow</h3>
							<p waBody="m" waColorText="quiet" waText>NgIf, NgFor, NgLet render Angular 17+ &#64;if, &#64;for, &#64;let template syntax from Java. Structural directives composed server-side, rendered client-side.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>